import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnEE: CultureInfo = {
  name: 'en-EE',
  displayName: 'English (Estonia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-EE',
  parent: CultureInfoEn
};
